import { usePageMeta } from "../hooks/usePageMeta";
import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../lib/motion";
import { SITE } from "../config/site";

const SEZIONI = [
  {
    titolo: "1. Titolare del trattamento",
    testo: `Il titolare del trattamento dei dati personali è ${SITE.name}, con sede a ${SITE.address}, contattabile all'indirizzo email ${SITE.email} o al numero ${SITE.phone}.`,
  },
  {
    titolo: "2. Dati raccolti",
    testo:
      "Attraverso il modulo contatti raccogliamo i seguenti dati: nome e cognome, numero di telefono, indirizzo email, percorso di interesse e contenuto del messaggio. Non raccogliamo categorie particolari di dati personali.",
  },
  {
    titolo: "3. Finalità del trattamento",
    testo:
      "I dati forniti sono utilizzati esclusivamente per rispondere alla tua richiesta di informazioni e per ricontattarti in merito ai percorsi di orientamento e formazione di tuo interesse. I dati non vengono utilizzati per finalità di marketing senza un tuo esplicito consenso.",
  },
  {
    titolo: "4. Base giuridica",
    testo:
      "Il trattamento si fonda sull'esecuzione di misure precontrattuali adottate su tua richiesta (art. 6, par. 1, lett. b del GDPR) e, ove necessario, sul tuo consenso espresso tramite l'apposita casella di accettazione presente nel modulo.",
  },
  {
    titolo: "5. Conservazione dei dati",
    testo:
      "I dati sono conservati per il tempo necessario a gestire la tua richiesta e per eventuali comunicazioni successive legate al percorso scelto. Puoi chiederne la cancellazione in qualsiasi momento.",
  },
  {
    titolo: "6. Comunicazione a terzi",
    testo:
      "I dati non sono ceduti a terzi né diffusi. Possono essere trattati da fornitori tecnici che supportano il funzionamento del sito, nel rispetto delle garanzie previste dal GDPR.",
  },
  {
    titolo: "7. I tuoi diritti",
    testo:
      "In qualità di interessato hai diritto di accesso, rettifica, cancellazione, limitazione e opposizione al trattamento dei tuoi dati personali, oltre al diritto di proporre reclamo all'autorità di controllo (Garante per la protezione dei dati personali).",
  },
  {
    titolo: "8. Esercizio dei diritti",
    testo: `Per esercitare i tuoi diritti o per qualsiasi domanda sulla privacy puoi scrivere a ${SITE.email} o chiamare il numero ${SITE.phone}.`,
  },
];

export default function Privacy() {
  usePageMeta(
    "Privacy Policy",
    "Informativa privacy di Centro Studi Forma Futuro: come trattiamo i dati raccolti tramite il modulo contatti."
  );

  return (
    <main>
      <PageHeader
        testId="page-privacy"
        eyebrow="Informativa"
        title="Privacy Policy."
        description="Come raccogliamo, utilizziamo e proteggiamo i tuoi dati personali, in conformità al Regolamento (UE) 2016/679 (GDPR)."
      />
      <section className="pb-20 lg:pb-28">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-10">
          <div className="space-y-10">
            {SEZIONI.map((s) => (
              <Reveal key={s.titolo}>
                <h2 className="text-xl sm:text-2xl font-bold tracking-tight text-navy">
                  {s.titolo}
                </h2>
                <p className="mt-3 text-sm sm:text-base text-slate-600 leading-relaxed">
                  {s.testo}
                </p>
              </Reveal>
            ))}
          </div>
          <Reveal className="mt-14 bg-azure-light border border-azure-soft rounded-[1.4rem] px-7 py-6">
            <p className="text-sm text-slate-600 leading-relaxed">
              Ultimo aggiornamento: settembre 2026. Questa informativa può
              essere aggiornata nel tempo: la versione vigente è sempre quella
              pubblicata su questa pagina.
            </p>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
